import "core-js/modules/es.array.fill.js";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { x } from '@xstyled/styled-components';
import { sizes } from '../../theme/sizes';
import { VeryHappyFaceIcon } from '../../icons/very-happy-face-icon';
export function VeryHappyFace(_ref) {
  var fill = _ref.fill;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  if (fill) return /*#__PURE__*/_jsx(x.p, {
    fontSize: sizes.emojiRattingSelectedSize,
    children: /*#__PURE__*/_jsx("span", {
      role: "img",
      "aria-label": t('ARIA_LABEL_VERY_HAPPY_FACE'),
      children: "\uD83D\uDE04"
    })
  });
  return /*#__PURE__*/_jsx(VeryHappyFaceIcon, {});
}